// extracted by mini-css-extract-plugin
export var defaultWrapper = "_kz-3";
export var downloadButton = "_kz-4";
export var fileContainer = "_kz-9 _kz-7";
export var fileContainerBase = "_kz-7";
export var fileContainerFixedHeight = "_kz-8 _kz-7";
export var fileInfo = "_kz-5";
export var fileInfoWidthRestricted = "_kz-6";
export var fileType = "_kz-1";
export var fileTypeName = "_kz-2";
export var image = "_kz-0";
export var link = "_kz-b";
export var overflowEllipsis = "_kz-a";